export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: 'Back',
            backToProject: 'Back to home',
            defaultTitle: 'Untitled Document',
            editTitle: 'Click to edit title',
            clickToEditName: 'Click to edit',
            screen: {
                single: 'Single Screen',
                split: 'Split Screen',
            },
            aiHiro: 'AI Chat',
            save: 'Save',
            saveOptions: 'Save Options',
            saveToFolder: 'Save to Folder',
            saveSuccess: 'Saved successfully',
            saveFailed: 'Save failed',
            export: 'Export',
            share: 'Share',
            sharePermissionDenied: 'Only the project owner can share',
            updateTitleSuccess: 'Title updated successfully',
            updateTitleFailed: 'Failed to update title',
            importing: 'Importing document...',
            importSuccess: 'Import successful',
            importFailed: 'Import failed',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: 'Add Source',
            createDocument: 'Create Document',
            selectDocumentType: 'Select document type and create',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: 'Blank',
            placeholder: 'Create a blank document',
            title: 'Blank Document',
            description: 'Create an empty document and start writing from scratch',
            action: 'Create Blank Document',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: 'Close Others',
            closeAll: 'Close All',
            files: 'Files',
            originalText: 'Original Text',
        },
    },
};
